"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vendor = void 0;
const commentItem_model_1 = require("../comment/commentItem.model");
class Vendor {
    constructor(data) {
        this.contracts = [];
        this.comments = [];
        if (data) {
            this.deserialize(data);
        }
    }
    deserialize(input) {
        var _a;
        Object.assign(this, input);
        this.id = input.id || input._id;
        this.comments = ((_a = input.comments) === null || _a === void 0 ? void 0 : _a.map((comment) => new commentItem_model_1.CommentItem(comment))) || [];
        return this;
    }
}
exports.Vendor = Vendor;
